import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import SubNav from "../menu/SubNav";
import Card from "../ui/Card";
import Footer from "../menu/Footer";
import FacematchVerificationHeader from "../verifications/facematch/FacematchVerificationHeader";
import FacematchService from "@/services/facematch";
import VerificationHeaderPlaceholder from "../placeholder/VerificationHeaderPlaceholder";
import * as Notification from "@/components/ui/Notification";
import useWebSocket from "react-use-websocket";
import AuthService from "@/services/auth";
import { FacematchVerificationContext } from "@/context/facematch_verification";
import VerificationStepPlaceholder from "../placeholder/VerificationStepPlaceholder";
import FacematchVisualCheck from "../verifications/facematch/FacematchVisualCheck";
import { AuthContext } from "@/context/auth";

export default function FacematchVerification() {
  const [, facematchVerificationDispatch] = useContext(
    FacematchVerificationContext
  );
  const [ready, setReady] = useState(false);
  const router = useHistory();
  const { session_id } = useParams();
  const [auth] = useContext(AuthContext);

  const socketUrl = `${process.env.REACT_APP_WS_HOST}/v3/websockets/online`;
  const { readyState, getWebSocket } = useWebSocket(socketUrl, {
    onOpen: async () => {},
    shouldReconnect: () => true,
  });

  useEffect(async () => {
    await getTask();
    return () => {};
  }, []);

  useEffect(async () => {
    if (readyState) {
      getWebSocket().send(
        JSON.stringify({
          auth: auth.auth.access_token,
          email: auth.user.email,
          firstname: auth.user.firstname,
          lastname: auth.user.lastname,
          profile_pic: auth.user.profile_pic,
          service: "FACEMATCH",
          session_id: session_id,
        })
      );
    }
  }, [readyState]);

  async function getTask() {
    await FacematchService.GetTask(session_id)
      .then(async (data) => {
        if (data.task.service_session_id === "") {
          router.push("/verifications/facematch");
          return;
        }
        await facematchVerificationDispatch({
          type: "SET_SESSION",
          payload: data,
        });
        console.log("data");
        console.log(data);
        setReady(true);
      })
      .catch((err) => {
        Notification.error(err.message);
      });
    return () => {};
  }

  return (
    <div>
      <div>
        <SubNav></SubNav>
        <div className="max-w-7xl mx-auto relative">
          <div className="verification-container">
            {ready ? (
              <FacematchVerificationHeader
                onUpdate={() => getTask()}
              ></FacematchVerificationHeader>
            ) : (
              <VerificationHeaderPlaceholder></VerificationHeaderPlaceholder>
            )}
          </div>
        </div>
        <div className="max-w-7xl mx-auto relative">
          <div className="flex flex-wrap mt-6">
            <Card className="w-full px-3 sm:px-0">
              <div>
                <div>
                  {ready ? (
                    <div>
                      <div className="p-6">
                        <FacematchVisualCheck
                          onUpdate={() => getTask()}
                        ></FacematchVisualCheck>
                      </div>
                    </div>
                  ) : (
                    <VerificationStepPlaceholder></VerificationStepPlaceholder>
                  )}
                </div>
              </div>
            </Card>
          </div>
          <Footer></Footer>
        </div>
      </div>
    </div>
  );
}
